// 还款状态 options
export const receivableStateOptions = [
  { label: '全部', value: '' },
  { label: '未结清', value: 0, type: 'warning' },
  { label: '已结清', value: 1, type: 'success' }
]

// 客户类型 options
export const customerTypeOptions = [
  { label: '全部', value: '' },
  { label: '个人', value: 1 },
  { label: '企业', value: 2 }
]

// 逾期阶段 options
export const overDueLevelOptions = [
  { label: '全部', value: '' },
  { label: '轻度', value: 1 },
  { label: '中度', value: 2 },
  { label: '重度', value: 3 }
]

// 跟进状态
export const followStateOptions = [
  { label: '待跟进', value: 0 },
  { label: '跟进中', value: 1 },
  { label: '已完成', value: 2 }
]

// 预提醒阶段 options
export const remindLevelOptions = [
  { label: '全部', value: '' },
  { label: 'T-0', value: 0 },
  { label: 'T-1', value: 1 },
  { label: 'T-2', value: 2 },
  { label: 'T-3', value: 3 },
  { label: 'T-4', value: 4 },
  { label: 'T-5', value: 5 },
  { label: 'T-6', value: 6 },
  { label: 'T-7', value: 7 }
]

// 收款状态
export const getStateOptions = [
  { label: '进行中', value: 0 },
  { label: '已完成', value: 1 },
  { label: '已作废', value: 2 }
]

// 收款方类型
export const payMethodOptions = [
  { label: '线下收款', value: 10 },
  { label: '线上代扣', value: 20 }
]

// 租赁状态
export const leaseStatusOptions = [
  { label: '发车待验车', value: 1500 },
  { label: '履约中', value: 2500 },
  { label: '退车待验车', value: 3500 },
  { label: '订单待核算', value: 4500 },
  { label: '费用待结算', value: 5000 },
  { label: '已关闭', value: 5500 }
]
// 租赁状态数据回显
export const leaseStatusKey = {
  1500: '发车待验车',
  2500: '履约中',
  3500: '退车待验车',
  4500: '订单待核算',
  5000: '费用待结算',
  5500: '已关闭'
}


